import { createSpotMarker } from 'app/core/markers/models';
import { InsertConvex } from './InsertConvex';
export const InsertSpot = (defaults) => {
    const createMarker = (point) => createSpotMarker(Object.assign(Object.assign({}, defaults), { x: point.x, y: point.y }));
    return InsertConvex(createMarker);
};
